import { Container, Box, CircularProgress } from '@mui/material';
import { Workspace } from './components/workspace';
import { WorkspaceSelector } from './components/workspace/WorkspaceSelector';
import { Auth } from './components/Auth';
import { ThemeProvider } from './theme/ThemeProvider';
import { useState, useEffect } from 'react';
import { initializeDatabase } from './utils/initDatabase';
import { useAuth } from './firebase/hooks/useAuth';

const App = () => {
  const { user, loading: authLoading } = useAuth();
  const [selectedWorkspace, setSelectedWorkspace] = useState<string | null>(null);
  const [isInitializing, setIsInitializing] = useState(true);

  useEffect(() => {
    const init = async () => {
      try {
        await initializeDatabase();
      } catch (error) {
        console.error('Failed to initialize database:', error);
      } finally {
        setIsInitializing(false);
      }
    };

    init();
  }, []);

  if (authLoading || isInitializing) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ThemeProvider>
      <Container maxWidth={false}>
        {user ? (
          selectedWorkspace ? (
            <Workspace workspaceId={selectedWorkspace} onExit={() => setSelectedWorkspace(null)} />
          ) : (
            <WorkspaceSelector onSelect={setSelectedWorkspace} />
          )
        ) : (
          <Auth />
        )}
      </Container>
    </ThemeProvider>
  );
};

export default App;